import { render, staticRenderFns } from "./kortingen.vue?vue&type=template&id=3397c9ef&"
import script from "./kortingen.vue?vue&type=script&lang=js&"
export * from "./kortingen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports